import Hero from 'components/Hero/Hero';
import DonateNow from 'components/DonateNow/DonateNow';
import AllCharities from 'components/AllCharities/AllCharities';
import AngelInfo from 'components/AngelInfo/AngelInfo';
import SunNFT from "components/SunflowerNFT/SunNFT";

const Main = () => {
  return (
    <>
      <Hero />
      <DonateNow />
      <AllCharities />
      <AngelInfo />
    </>
  );
};

export default Main;